import { Copy as CopyIcon, Key } from "@phosphor-icons/react";

export const Copy = () => <CopyIcon size={12} />;
export const KeyIcon = () => <Key size={16} weight="duotone" />;
